module.exports = __webpack_public_path__ + "static/media/guiaDeEstudioPrimerExamen.7ac82bd1.pdf";